import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4ad7ac67")

_pushScopeId("data-v-4ad7ac67")
const _hoisted_1 = { class: "no-margin-bottom" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_badge = _resolveComponent("f7-badge")
  const _component_f7_icon = _resolveComponent("f7-icon")
  const _component_f7_link = _resolveComponent("f7-link")

  return (_openBlock(), _createBlock(_component_f7_link, {
    "reload-all": "",
    href: _ctx.href,
    "no-link-class": "",
    view: ".view-main"
  }, {
    default: _withId(() => [
      _createVNode("div", {
        class: [{ selected: _ctx.selected }]
      }, [
        _createVNode(_component_f7_icon, { f7: _ctx.icon }, {
          default: _withId(() => [
            (_ctx.badge && _ctx.badge != '')
              ? (_openBlock(), _createBlock(_component_f7_badge, {
                  key: 0,
                  color: "red"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.badge), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["f7"]),
        _createVNode("h4", _hoisted_1, _toDisplayString(_ctx.title), 1)
      ], 2)
    ]),
    _: 1
  }, 8, ["href"]))
})